export default __webpack_public_path__ + "static/media/blueClockBold.48463b4a.svg";